import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { ToastContainer } from 'react-toastify';
import ScrollToTop from 'components/common/ScrollToTop';
import ToastCloseButton from 'components/common/ToastCloseButton';
import { AppContextProvider } from './contexts/AppContext';
import settings from './config/settings';
import i18nMessages from './i18n';
import RootRouter from './router/RootRouter';
import apolloClient from './graphql/apollo';
import 'normalize.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-quill-new/dist/quill.snow.css';
import 'rc-pagination/assets/index.css';
import './styles/index.scss';

// Without a locale (no REACT_APP_DEFAULT_LOCALE) react-intl falls back to its default locale; it
// treats '' as it treated undefined.
const locale = window?.localStorage?.getItem('language') || settings.defaultLocale || '';

const App = () => (
  <ApolloProvider client={apolloClient}>
    <Router basename={settings.publicUrl}>
      <ScrollToTop />
      <IntlProvider locale={locale} messages={i18nMessages[locale]}>
        <AppContextProvider locale={locale}>
          <RootRouter />
        </AppContextProvider>
      </IntlProvider>
    </Router>
    {/* react-toastify 11 injects its CSS. The props (and styles/toastify.scss) keep the toasts of
        react-toastify 5: coloured background without an icon, its close glyph, closed by a click,
        draggable with the mouse too. */}
    <ToastContainer
      theme="colored"
      icon={false}
      closeButton={ToastCloseButton}
      closeOnClick
      draggable
    />
  </ApolloProvider>
);

export default App;
